import type { ConfirmDialogProps } from '@/components/ui/ConfirmDialog'

/**
 * Resident confirms — Save Changes shell with sectioned header/footer chrome
 * (grey-blue title bar + footer action bar), Confirm then Skip/Cancel.
 */
export const residentConfirmPresentation = {
  presentation: 'saveChanges',
  primaryFirst: true,
  actionStyle: 'application',
  sectionedChrome: true,
  equalWidthActions: true,
} as const satisfies Partial<ConfirmDialogProps>

/**
 * Remove Document confirms — solid primary Delete + grey Cancel (saveChanges shell).
 */
export const residentRemoveDocumentPresentation = {
  presentation: 'saveChanges',
  primaryFirst: true,
} as const satisfies Partial<ConfirmDialogProps>
